// extracted by mini-css-extract-plugin
export var conversationView = "BevFE";
export var firstColumnNoTwistyWithHeaders = "DMjcl";
export var firstColumnWithHeaders = "mn28d";
export var flagDueDateStyle = "b_utv";
export var itemView = "NV2gU";
export var mclLeadingControlsContainer = "Yhp01";
export var mclLeadingControlsContainerInlinePreview = "ORB1S";
export var mclLeadingControlsContainerNoTwisty = "jO6nB";
export var redDark = "F4qQX";
export var sortedContentFlagStatusIcon = "nDyt_";
export var sortedContentImportanceIcon = "ftwkk";
export var sortedContentPriorityIcon = "tWz7C";
export var standardizedFirstColumn = "mXLG_";
export var standardizedSecondColumn = "Gts_D";